window.googleApiLoaded = function() {
  e = document.createEvent('CustomEvent');
  e.initCustomEvent('maps:onload', true, true);
  window.dispatchEvent(e);
}
